/**
 * Hero images for each service detail page.
 * These are sensible Unsplash placeholders — swap for client-supplied uploads
 * by replacing the `src` values below. The `alt` strings come straight from
 * the brief and should be kept descriptive.
 */
const u = (id) => `https://images.unsplash.com/${id}?w=1400&q=80&auto=format&fit=crop`;

export const HERO_IMAGES = {
  'website-development': {
    src: u('photo-1517694712202-14dd9538aa97'),
    alt: 'developer building a website on screen',
  },
  'web-app-development': {
    src: u('photo-1551288049-bebda4e38f71'),
    alt: 'team working across a data dashboard',
  },
  'mobile-app-development': {
    src: u('photo-1512941937669-90a1b58e7e9c'),
    alt: 'hand holding a phone with an app open',
  },
  'custom-software-development': {
    src: u('photo-1531482615713-2afd69097998'),
    alt: 'engineers collaborating at multiple monitors',
  },
  'ecommerce-website-development': {
    src: u('photo-1607082348824-0a96f2a4b9da'),
    alt: 'person checking out on a phone',
  },
  'ai-solutions': {
    src: u('photo-1677442136019-21780ecad995'),
    alt: 'glowing neural network / AI assistant interface',
  },
};
